<template lang="html">

  <section  class="app-sidebar fixed-top print_hide">
    <nav class="sidebar sidebar-offcanvas" id="sidebar">
      <ul class="nav">
        <li class="nav-item nav-profile">
          <div class="nav-link">
            <!--<div class="profile-image float-left">-->
              <!--<img src="../../assets/images/logo_transparent_background.png" alt="image"/>-->
            <!--</div>-->
            <div style="height: 58px; padding-top: 25px;text-align: center;">
              <h4 class="pl-1" style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 3; /* after 3 line show ... */-webkit-box-orient: vertical;">{{$store.state.company.name ? $store.state.company.name : 'Nordtech'}}</h4>
            </div>
          </div>
        </li>
        <li class="nav-item nav-profile">
          <div>
          </div>
        </li>
        <li v-show="$store.state.user.data.role === 'System Admin'" class="nav-item"><router-link class="nav-link" to="/dashboard"><i class="mdi mdi-view-dashboard menu-icon"></i><span class="menu-title">{{$t('Dashboard')}}</span></router-link></li>
        <li v-show="$store.state.user.data.role === 'System Admin'" class="nav-item"><router-link class="nav-link" to="/system-admins/"><i class="menu-icon mdi mdi-account-multiple"></i>{{$t('System Admins')}}</router-link></li>
        <li v-show="$store.state.user.data.role === 'System Admin'" class="nav-item"><router-link class="nav-link" to="/licenses/"><i class="menu-icon mdi mdi-cards"></i>{{$t('Licenses')}}</router-link></li>
        <li v-show="$store.state.user.data.role === 'System Admin'" class="nav-item"><router-link class="nav-link" to="/companies/"><i class="menu-icon mdi mdi-city"></i>{{$t('Companies')}}</router-link></li>
        <li v-show="['Administrator'].includes($store.state.user.data.role)"  class="nav-item"><router-link class="nav-link" to="/my-licenses"><i class="menu-icon mdi mdi-cards"></i>{{$t('Licenses')}}</router-link></li>
        <li v-show="['Administrator'].includes($store.state.user.data.role)"  class="nav-item"><router-link class="nav-link" to="/licensed-users/"><i class="menu-icon mdi mdi-account-multiple"></i>{{$t('Users')}}</router-link></li>
        <li v-show="['Administrator', 'Manager', 'Supervisor'].includes($store.state.user.data.role)"  class="nav-item"><router-link class="nav-link" to="/my-companies"><i class="menu-icon mdi mdi-city"></i>{{$t('Companies')}}</router-link></li>
        <li v-if="showDevices" class="nav-item"><router-link class="nav-link" to="/devices/"><i class="menu-icon mdi mdi-access-point-network"></i>{{$t('Devices')}}</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/download-center"><i class="mdi mdi-download menu-icon"></i><span class="menu-title">{{$t('Download Center')}}</span></router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/support"><i class="mdi mdi-help-circle menu-icon"></i><span class="menu-title">{{$t('Support')}}</span></router-link></li>

      </ul>
      <div class="profile-image float-left" style="width: 100%;text-align: center;position: absolute;bottom: 0;">
        <img style="width: 50%;" src="../../assets/images/logo_transparent_background.png" alt="image"/>
      </div>
    </nav>
  </section>

</template>

<script lang="js">
export default {
  name: 'app-sidebar',
  computed: {
    showDevices () {
      if (this.$store.state.user.data.role === 'System Admin') {
        return true
      }
      if (this.$store.state.userPreferences) {
        return this.$store.state.userPreferences.labelTypes.includes('DEVICES')
      }
      return this.$store.state.companyPreferences.labelTypes.includes('DEVICES')
    }
  }
}
</script>

<style scoped lang="scss">
.app-sidebar {

}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppSidebar.vue